import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const EmailListTabSkeleton: React.FC = () => (
  <div className="email-list-tab-skeleton-container">
    <div className="email-list-tab-header-send-email-container">
      <SkeletonLoading width={16} height={16} />
      <SkeletonLoading width={69} height={14} />
    </div>
    <div className="email-list-tab-body-main-container">
      {Array.from({ length: 3 }).map(() => (
        <div className="email-list-tab-body-container">
          <div className="email-list-tab-body-header-container">
            <div className="email-list-tab-body-header-left-container">
              <SkeletonLoading width={32} height={32} circle />
              <div>
                <SkeletonLoading width={223} height={14} />
                <SkeletonLoading width={137} height={14} />
              </div>
            </div>
            <div className="email-list-tab-body-header-right-container">
              <SkeletonLoading width={77} height={14} />
              <SkeletonLoading width={24} height={24} circle />
              <SkeletonLoading width={24} height={24} circle />
              <SkeletonLoading width={24} height={24} circle />
            </div>
          </div>
          <div className="email-list-tab-body-content-container">
            <SkeletonLoading width={123} height={18} />
            <SkeletonLoading width={454} height={14} />
            <SkeletonLoading width={388} height={14} />
            <SkeletonLoading width={240} height={14} />
            <SkeletonLoading width={144} height={14} />
          </div>
        </div>
      ))}
    </div>
  </div>
);
export default EmailListTabSkeleton;
